var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C15.0938 0 16 0.90625 16 2V11C16 12.125 15.0938 13 14 13H9.5L5.59375 15.9375C5.5 16 5.4375 16 5.375 16C5.15625 16 5 15.875 5 15.625V13H2C0.875 13 0 12.125 0 11V2C0 0.90625 0.875 0 2 0H14ZM15 11V2C15 1.46875 14.5312 1 14 1H2C1.4375 1 1 1.46875 1 2V11C1 11.5625 1.4375 12 2 12H6V14.375L8.875 12.2188L9.15625 12H14C14.5312 12 15 11.5625 15 11ZM10.3438 7.4375C10.5312 7.21875 10.8438 7.1875 11.0625 7.375C11.2812 7.5625 11.3125 7.875 11.125 8.09375C10.3438 9 9.1875 9.5 8 9.5C6.78125 9.5 5.625 9 4.84375 8.09375C4.6875 7.875 4.6875 7.5625 4.90625 7.375C5.125 7.1875 5.4375 7.21875 5.625 7.4375C6.21875 8.125 7.0625 8.5 8 8.5C8.90625 8.5 9.78125 8.125 10.3438 7.4375ZM6 5.75C5.5625 5.75 5.25 5.4375 5.25 5C5.25 4.59375 5.5625 4.25 6 4.25C6.40625 4.25 6.75 4.59375 6.75 5C6.75 5.4375 6.40625 5.75 6 5.75ZM10 5.75C9.5625 5.75 9.25 5.4375 9.25 5C9.25 4.59375 9.5625 4.25 10 4.25C10.4062 4.25 10.75 4.59375 10.75 5C10.75 5.4375 10.4062 5.75 10 5.75Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.85c609ee.svg";
export { ForwardRef as ReactComponent };